import React, { useState } from 'react';
import './UsedVehicleLoan.css';
import UsedVehicleBanner from '../images/used-vehicle-loan-banner.jpg';
import UsedVehicleInner from '../images/Used-Vehicle-Loan-scaled.jpeg';

const UsedVehicleLoan = () => {
  const [activeTab, setActiveTab] = useState('eligibility');
  const [activeSubTab, setActiveSubTab] = useState('individual');
  const [activeNestedTab, setActiveNestedTab] = useState('partnership');

  return (
    <div className="used-vehicle-loan-page" style={{ backgroundImage: `url(${UsedVehicleInner})` }}>
      {/* Banner Section */}
      <section className="used-vehicle-banner">
        <div className="vehicle-banner-container">
          <div className="vehicle-banner-left">
            <div className="vehicle-banner-image" style={{ backgroundImage: `url(${UsedVehicleBanner})` }}>
              <div className="vehicle-image-overlay">
                <h1 className="vehicle-banner-title">USED VEHICLE LOAN</h1>
              </div>
            </div>
          </div>
          <div className="vehicle-banner-right">
            <div className="vehicle-banner-content">
              <h2 className="vehicle-banner-subtitle">WE OFFER A FULL RANGE OF USED VEHICLE LOAN SERVICES</h2>
              <p className="vehicle-banner-description">
                Vehicle loan is a secured loan that is designed for the purchase of vehicles. By pledging the vehicle itself as a security, borrowers can finance a significant portion of their vehicle's cost by repaying the loan through manageable monthly instalments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="vehicle-features-section">
        <div className="vehicle-features-container">
          <h2 className="vehicle-features-heading">FEATURES/BENEFITS</h2>
          <div className="vehicle-features-content">
            <div className="vehicle-features-image-wrapper">
              <img src={UsedVehicleInner} alt="Used Vehicle Loan Features" className="vehicle-features-image" />
            </div>
            <div className="vehicle-features-list">
              <div className="vehicle-feature-item">
                <h3 className="vehicle-feature-title">MAXIMUM FUNDING</h3>
                <p className="vehicle-feature-description">Avail a flexible loan tenure of up to 15 years.</p>
              </div>
              <div className="vehicle-feature-item">
                <h3 className="vehicle-feature-title">LOAN TENURE</h3>
                <p className="vehicle-feature-description">Upto 4 years.</p>
              </div>
              <div className="vehicle-feature-item">
                <h3 className="vehicle-feature-title">MINIMAL PAPERWORK</h3>
                <p className="vehicle-feature-description">Documentation process is simple.</p>
              </div>
              <div className="vehicle-feature-item">
                <h3 className="vehicle-feature-title">ACCESSIBLE SERVICE</h3>
                <p className="vehicle-feature-description">Pan India branch Network</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and Documents Section */}
      <section className="vehicle-eligibility-section">
        <div className="vehicle-eligibility-container">
          <div className="vehicle-tabs">
            <button 
              className={`vehicle-tab ${activeTab === 'eligibility' ? 'active' : ''}`}
              onClick={() => setActiveTab('eligibility')}
            >
              Eligibility Criteria
            </button>
            <button 
              className={`vehicle-tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              Required Documents
            </button>
          </div>

          {activeTab === 'eligibility' && (
            <div className="vehicle-tab-content">
              <p className="vehicle-eligibility-text">
                Individual should be between 21-55 years of age.
              </p>
            </div>
          )}

          {activeTab === 'documents' && (
            <div className="vehicle-tab-content">
              <div className="vehicle-sub-tabs">
                <button 
                  className={`vehicle-sub-tab ${activeSubTab === 'individual' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveSubTab('individual');
                    setActiveNestedTab('partnership');
                  }}
                >
                  For Individual Cases
                </button>
                <button 
                  className={`vehicle-sub-tab ${activeSubTab === 'non-individual' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveSubTab('non-individual');
                    setActiveNestedTab('salaried');
                  }}
                >
                  For Non-Individual Cases
                </button>
              </div>

              {activeSubTab === 'individual' && (
                <>
                  <div className="vehicle-nested-tabs">
                    <button 
                      className={`vehicle-nested-tab ${activeNestedTab === 'partnership' ? 'active' : ''}`}
                      onClick={() => setActiveNestedTab('partnership')}
                    >
                      Partnership Firm / Trust / Society
                    </button>
                    <button 
                      className={`vehicle-nested-tab ${activeNestedTab === 'private-limited' ? 'active' : ''}`}
                      onClick={() => setActiveNestedTab('private-limited')}
                    >
                      Private Limited/Limited Companies
                    </button>
                  </div>

                  {activeNestedTab === 'partnership' && (
                    <div className="vehicle-documents-grid">
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Audited Balance Sheet</li>
                          <li>P & L Account & ITR for Latest 2 years</li>
                          <li>Latest 3 months Bank Statement</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">EMPLOYMENT/BUSINESS CONTINUITY PROOF</h3>
                        <ul className="vehicle-documents-list">
                          <li>Shop & Establishment Act Certificate</li>
                          <li>SSI or MSME Registration Certificate</li>
                          <li>Sales VAT or VAT Certificate</li>
                          <li>Current A/C Statement</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">ADDITIONAL DOCUMENTS</h3>
                        <ul className="vehicle-documents-list">
                          <li>PAN Cards</li>
                          <li>Authority Letter by all partners</li>
                          <li>Board resolution for Trust</li>
                        </ul>
                      </div>
                    </div>
                  )}

                  {activeNestedTab === 'private-limited' && (
                    <div className="vehicle-documents-grid">
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Audited Balance Sheet</li>
                          <li>P & L Account & ITR for Latest 2 years</li>
                          <li>Latest 3 months Bank Statement</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">EMPLOYMENT/BUSINESS CONTINUITY PROOF</h3>
                        <ul className="vehicle-documents-list">
                          <li>Shop & Establishment Act Certificate</li>
                          <li>SSI or MSME Registration Certificate</li>
                          <li>Sales VAT or VAT Certificate</li>
                          <li>Current A/C Statement</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">ADDITIONAL DOCUMENTS</h3>
                        <ul className="vehicle-documents-list">
                          <li>List of Directors & Shareholding Pattern</li>
                          <li>PAN Card</li>
                          <li>Board resolution</li>
                          <li>Certificate of Commencement of Business for Ltd.Co</li>
                        </ul>
                      </div>
                    </div>
                  )}
                </>
              )}

              {activeSubTab === 'non-individual' && (
                <>
                  <div className="vehicle-nested-tabs">
                    <button 
                      className={`vehicle-nested-tab ${activeNestedTab === 'salaried' ? 'active' : ''}`}
                      onClick={() => setActiveNestedTab('salaried')}
                    >
                      For Salaried Employees
                    </button>
                    <button 
                      className={`vehicle-nested-tab ${activeNestedTab === 'self-employed' ? 'active' : ''}`}
                      onClick={() => setActiveNestedTab('self-employed')}
                    >
                      For Self Employed
                    </button>
                  </div>

                  {activeNestedTab === 'salaried' && (
                    <div className="vehicle-documents-grid">
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">OFFICE / BUSINESS PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Telephone Bill</li>
                          <li>Electricity Bill</li>
                          <li>Shop & Establishment Act Certificate</li>
                          <li>Sales Tax or VAT Certificate</li>
                          <li>Current A/C Statement</li>
                          <li>Regd Lease with other Utility Bills</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">AGE PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Pan Card</li>
                          <li>Driving Licence</li>
                          <li>Passport</li>
                          <li>Birth Certificate</li>
                          <li>Bankers Verification</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Latest ITR</li>
                          <li>Last 3 Month Bank Statement</li>
                        </ul>
                      </div>
                    </div>
                  )}

                  {activeNestedTab === 'self-employed' && (
                    <div className="vehicle-documents-grid">
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">AGE PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Pan Card</li>
                          <li>Driving License</li>
                          <li>Passport</li>
                          <li>Birth Certificate</li>
                          <li>Property title documents</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">EMPLOYMENT/BUSINESS CONTINUITY PROOF</h3>
                        <ul className="vehicle-documents-list">
                          <li>Copy of Appointment Letter</li>
                          <li>Date of Joining on Salary Slip</li>
                          <li>ITR of Form 16</li>
                          <li>Work Experience Certificate</li>
                          <li>Relieving Certificate</li>
                        </ul>
                      </div>
                      <div className="vehicle-documents-card">
                        <h3 className="vehicle-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                        <ul className="vehicle-documents-list">
                          <li>Last 2 Salary Slips & Latest Form 16</li>
                          <li>Last 3 Month Bank Statement</li>
                        </ul>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Learn More Section */}
      <section className="vehicle-learn-more-section">
        <div className="vehicle-learn-more-container">
          <div className="vehicle-learn-more-content">
            <h2 className="vehicle-learn-more-title">Learn More About Our Services</h2>
            <p className="vehicle-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="vehicle-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default UsedVehicleLoan;

